import React from "react";
import { Stack } from "@mui/material";
import { FtlOption } from "../../shared/interfaces/GameLogicTypes";
import { renderCueContent, stripCueMarkup } from "../../shared/helper/renderCueContent";
import "./FtlChoicePanel.css";

export interface FtlChoicePanelProps {
  options: FtlOption[];
  isCzar: boolean;
  isAlive: boolean;
  selectedChoice: number | null;
  onSelect: (choice: number) => void;
  czarLocked: boolean;
  timeLeft: number;
  isMobile?: boolean;
}

function getFontSize(text: string): string {
  const len = typeof text === "string" ? stripCueMarkup(text).length : 0;
  if (len > 80) return "0.75rem";
  if (len > 40) return "0.85rem";
  return "1rem";
}

const FtlChoicePanel = React.memo(function FtlChoicePanel({
  options,
  isCzar,
  isAlive,
  selectedChoice,
  onSelect,
  czarLocked,
  timeLeft,
  isMobile,
}: FtlChoicePanelProps) {

  const gridClass = `ftl-choice-grid options-${options.length}`;

  return (
    <Stack spacing={2} alignItems="center" sx={{ width: "100%" }}>
      {/* Option grid */}
      <div className={gridClass}>
        {options.map((option) => {
          const isSelected = selectedChoice === option.index;
          const disabled = !isAlive;
          const text = typeof option.cue.content === "string" ? option.cue.content : "";

          let className = "ftl-option-btn";
          if (isSelected) className += " selected";
          if (disabled) className += " disabled";
          if (isCzar && isSelected) className += " czar-locked-in";
          if (czarLocked && !isCzar) className += " ftl-panel-blink";

          return (
            <div
              key={option.index}
              className={className}
              style={{
                backgroundColor: option.color,
                fontSize: getFontSize(text),
              }}
              onClick={() => {
                if (disabled) return;
                if (isCzar && selectedChoice !== null) return; // czar already locked
                onSelect(option.index);
              }}
            >
              {/* Resolved friend names arrive wrapped in <f> tags — render, don't print. */}
              {renderCueContent(text)}
            </div>
          );
        })}
      </div>

    </Stack>
  );
});

export default FtlChoicePanel;
